<template>
	<div class="oidc-callback">
		<div class="status-box">
			<i v-if="loading" class="el-icon-loading status-icon"></i>
			<i v-else class="el-icon-warning-outline status-icon error"></i>
			<div class="status-title">{{ title }}</div>
			<el-button v-if="!loading" type="primary" @click="goLogin">返回登录</el-button>
		</div>
	</div>
</template>

<script>
import { apiOidcLoginResult } from '@/apis/oidc.api'
import { clearLS } from '@/utils/storage'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'OidcCallback',
	data() {
		return {
			loading: true,
			title: '正在登录...',
		}
	},
	created() {
		this.handleCallback()
	},
	methods: {
		...mapActions({
			applyLoginResult: 'oidc/applyLoginResult',
			generateRoutes: 'app/generateRoutes',
			getDataList: 'common/getDataList',
		}),
		async handleCallback() {
			clearLS()
			const { ticket, error } = this.$route.query
			if (error) {
				this.loginFail(error)
				return
			}
			if (!ticket) {
				this.loginFail('登录状态已过期，请重新进入')
				return
			}
			try {
				const result = await apiOidcLoginResult(ticket)
				const { returnUrl, ...loginResult } = result
				await this.applyLoginResult(loginResult)
				const routes = await this.generateRoutes()
				if (!routes?.length) {
					this.loginFail('暂无项目访问权限，请联系管理员')
					return
				}
				await this.getDataList()
				const target = this.resolveTarget(returnUrl, routes)
				this.$router.replace(target)
			} catch (err) {
				this.loginFail(err?.message || '单点登录失败，请重试')
			}
		},
		resolveTarget(returnUrl, routes) {
			if (returnUrl && this.hasRoutePermission(returnUrl)) {
				return returnUrl
			}
			return this.getFirstChild(routes).fullPath
		},
		hasRoutePermission(returnUrl) {
			const resolved = this.$router.resolve(returnUrl)
			const route = resolved?.route
			if (!route?.matched?.length) {
				return false
			}
			return route.matched.every(item => {
				const permissions = item.meta?.permissions || []
				if (!permissions.length) return true
				return permissions.some(permission => this.permissions.includes(permission))
			})
		},
		getFirstChild(list) {
			if (list[0].children?.length) return this.getFirstChild(list[0].children)
			return list[0]
		},
		loginFail(message) {
			clearLS()
			this.loading = false
			this.title = message
			this.$message.error(message)
		},
		goLogin() {
			this.$router.replace('/login')
		},
	},
	computed: {
		...mapGetters({
			permissions: 'permissions',
		}),
	},
}
</script>

<style lang="scss" scoped>
.oidc-callback {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f5f7fb;
}

.status-box {
	width: 320px;
	min-height: 180px;
	padding: 32px 24px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 8px 24px rgba(23, 39, 68, 0.08);
	text-align: center;
}

.status-icon {
	font-size: 32px;
	color: #3b7cff;
}

.status-icon.error {
	color: #f56c6c;
}

.status-title {
	margin: 18px 0 24px;
	font-size: 16px;
	color: #1f2d3d;
}
</style>
